import React from 'react';
import { useSelector } from 'react-redux';
import AudioBlock from '../../../SegmentBuilder/Shared/AudioBlock';
import CollapsibleAudios from './CollapsibleAudios';
import { FaCamera } from 'react-icons/fa';
import EmptyContent from '../../EmptyContent';

function AudiosTab() {
  const { segments } = useSelector((state) => state?.hotbar);

  // Calculate the total number of audios
  const totalAudios = segments?.reduce((sum, segment) => {
    return sum + (segment?.items?.audios?.length || 0);
  }, 0);

  return (
    <>
      {totalAudios > 0 ? (
        segments?.map((segment) =>
          segment?.items?.audios?.length ? (
            <CollapsibleAudios
              key={segment.title} // Assuming title is unique
              audios={segment.items.audios}
              icon={<FaCamera />}
              title={segment.title}
              segmentColor={segment.segmentColor}
            />
          ) : null
        )
      ) : (
        <EmptyContent />
      )}
    </>
  );
}

export default AudiosTab;
